import React from 'react';
import { CheckboxAccordion } from './CheckboxAccordion';
import { useFormikContext } from 'formik';
import { set } from 'lodash-es';

export type CheckboxAccordionOption = {
  label: string;
  checked: boolean;
  /** This points to the path in the formik values object, check storybook for an example */
  name: string;
  disabled?: boolean;
};
type ChecboxAccordionFieldProps = {
  title: string;
  options: CheckboxAccordionOption[];
};
export function CheckboxAccordionField({
  title,
  options,
}: ChecboxAccordionFieldProps) {
  const formik = useFormikContext<typeof options>();

  // Transform the options into a CheckboxAccordion option
  const checkboxAccordionOptions = options.map((option) => ({
    label: option.label,
    checked: option.checked,
    name: option.name,
  }));

  return (
    <CheckboxAccordion
      title={title}
      options={checkboxAccordionOptions}
      onChange={(newOptions) => {
        const newVals = { ...formik.values };

        // This should keep any names that are not in the new options the same
        for (const option of newOptions) {
          set(newVals, option.name, option.checked);
        }

        formik.setValues(newVals);
      }}
    />
  );
}
